var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPorterAlert4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4a8 8 0 1 0 8 8 8.01 8.01 0 0 0-8-8zm2.696 10.696a.727.727 0 0 1-1.028 0l-2.182-2.182a.728.728 0 0 1-.213-.514V7.636a.728.728 0 0 1 1.454 0V11.7l1.969 1.969a.728.728 0 0 1 0 1.028z",
    fill: "#6C7C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorterAlert4);
export default __webpack_public_path__ + "static/media/porter_alert4.8d65fc87cfae1b0538ca6b4296a2f070.svg";
export { ForwardRef as ReactComponent };